import { RouteType } from "routes/types";
import { lazy } from "react";

const Element = lazy(() => import("./index"));

const route: RouteType = {
  id: 300001,
  parentId: 300000,
  name: "DevInput",
  label: "Input",
  path: "input",
  icon: "form",
  element: Element,
  admin: false,
  hidden: false,
};

export default route;
